/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";

export type GetSocialBilibiliVideoinfoRequest = {
  aid?: string | undefined;
  bvid?: string | undefined;
};

export const GetSocialBilibiliVideoinfoRequest$zodSchema: z.ZodType<
  GetSocialBilibiliVideoinfoRequest
> = z.object({
  aid: z.string().describe(
    "视频的AV号 (aid)，纯数字格式。`aid`和`bvid`任选其一即可。",
  ).optional(),
  bvid: z.string().describe(
    "视频的BV号 (bvid)，例如 `BV117411r7R1`。`aid`和`bvid`任选其一即可。",
  ).optional(),
});

/**
 * 视频UP主信息。
 */
export type Owner = {
  mid?: number | undefined;
  name?: string | undefined;
  face?: string | undefined;
};

export const Owner$zodSchema: z.ZodType<Owner> = z.object({
  face: z.string().optional(),
  mid: z.number().optional(),
  name: z.string().optional(),
}).describe("视频UP主信息。");

/**
 * 视频的核心数据统计。
 */
export type Stat = {
  view?: number | undefined;
  danmaku?: number | undefined;
  reply?: number | undefined;
  favorite?: number | undefined;
  coin?: number | undefined;
  share?: number | undefined;
  like?: number | undefined;
};

export const Stat$zodSchema: z.ZodType<Stat> = z.object({
  coin: z.number().optional(),
  danmaku: z.number().optional(),
  favorite: z.number().optional(),
  like: z.number().optional(),
  reply: z.number().optional(),
  share: z.number().optional(),
  view: z.number().optional(),
}).describe("视频的核心数据统计。");

export type GetSocialBilibiliVideoinfoPage = {
  cid?: number | undefined;
  page?: number | undefined;
  part?: string | undefined;
  duration?: number | undefined;
};

export const GetSocialBilibiliVideoinfoPage$zodSchema: z.ZodType<
  GetSocialBilibiliVideoinfoPage
> = z.object({
  cid: z.number().optional(),
  duration: z.number().optional(),
  page: z.number().optional(),
  part: z.string().optional(),
});

/**
 * 成功！返回Bilibili视频的详细信息。
 */
export type GetSocialBilibiliVideoinfoResponse = {
  bvid?: string | undefined;
  aid?: number | undefined;
  videos?: number | undefined;
  tname?: string | undefined;
  copyright?: number | undefined;
  pic?: string | undefined;
  title?: string | undefined;
  pubdate?: number | undefined;
  ctime?: number | undefined;
  desc?: string | undefined;
  duration?: number | undefined;
  owner?: Owner | undefined;
  stat?: Stat | undefined;
  pages?: Array<GetSocialBilibiliVideoinfoPage> | undefined;
};

export const GetSocialBilibiliVideoinfoResponse$zodSchema: z.ZodType<
  GetSocialBilibiliVideoinfoResponse
> = z.object({
  aid: z.number().optional(),
  bvid: z.string().optional(),
  copyright: z.number().optional(),
  ctime: z.number().optional(),
  desc: z.string().optional(),
  duration: z.number().optional(),
  owner: z.lazy(() => Owner$zodSchema).optional(),
  pages: z.array(z.lazy(() => GetSocialBilibiliVideoinfoPage$zodSchema))
    .optional(),
  pic: z.string().optional(),
  pubdate: z.number().optional(),
  stat: z.lazy(() => Stat$zodSchema).optional(),
  title: z.string().optional(),
  tname: z.string().optional(),
  videos: z.number().optional(),
}).describe("成功！返回Bilibili视频的详细信息。");
